import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import ProfilePage from '../../components/ProfilePage/ProfilePage';

const ProfilePageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <ProfilePage />
    </ProtectedRoute>
  );
};

export default ProfilePageRoute;